const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"evaBellFill0\"><g id=\"evaBellFill1\"><path id=\"evaBellFill2\" fill=\"currentColor\" d=\"m20.52 15.21l-1.8-1.81V8.94a6.86 6.86 0 0 0-5.82-6.88a6.74 6.74 0 0 0-7.62 6.67v4.67l-1.8 1.81A1.64 1.64 0 0 0 4.64 18H8v.34A3.84 3.84 0 0 0 12 22a3.84 3.84 0 0 0 4-3.66V18h3.36a1.64 1.64 0 0 0 1.16-2.79ZM14 18.34A1.88 1.88 0 0 1 12 20a1.88 1.88 0 0 1-2-1.66V18h4Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;
